// The Gibberfish Classroom Chrome extension: on youtube.com it brings the
// subtitles, translations and tracking to videos that can't play on this site.
// Its content script marks <html data-gibberfish-extension="version"> here.

/** The Chrome Web Store listing (unlisted: only people with this link can find it).
 *  Submitted for review 2026-10-03; the link works once Google approves it. */
export const EXTENSION_ID = 'hoplijlmdhlcfambgicnocpmfihkldmn';
/** Flip to true once Google approves it — until then the store page says "unavailable". */
const APPROVED = false;
export const EXTENSION_URL = APPROVED ? `https://chromewebstore.google.com/detail/${EXTENSION_ID}` : '';

export const extensionInstalled = () => !!document.documentElement.dataset.gibberfishExtension;

export const youtubeUrl = (videoId: string) => `https://www.youtube.com/watch?v=${videoId}`;

// ── Connecting the extension (extension/src/site.ts) ────────────────────────
// A signed-in student opens the site and the extension isn't signed in as them:
// get a one-time sign-in code made for the extension (student-accounts'
// extension_link) and hand it over. The extension signs in with it and gets its
// own session, so YouTube just works next time, with no typing.

let connecting = false;

/** Connect the extension to this student, if it's installed and not already them. Quiet if anything fails. */
export async function connectExtension(userId: string | undefined): Promise<void> {
  if (!userId || connecting) return;
  // The extension's script marks the page as it starts; give it a moment to say who it's signed in as.
  for (let i = 0; i < 10 && document.documentElement.dataset.gibberfishExtensionUser === undefined; i++) {
    if (!extensionInstalled() && i >= 3) return;
    await new Promise(r => setTimeout(r, 300));
  }
  if (!extensionInstalled() || document.documentElement.dataset.gibberfishExtensionUser === userId) return;
  connecting = true;
  try {
    const { supabase } = await import('./supabase');
    const { data, error } = await supabase.functions.invoke('student-accounts', { body: { action: 'extension_link' } });
    if (error || typeof data?.token_hash !== 'string') return;
    window.postMessage({ type: 'gibberfish:connect', token_hash: data.token_hash }, window.location.origin);
  } catch { /* try again next visit */ }
  finally { connecting = false; }
}
